import MonthlyFinancialPositionItem from './MonthlyFinancialPositionItem';
import MonthlyFinancialPositionForeseeableFinancialChanges from './MonthlyFinancialPositionForeseeableFinancialChanges';
import type { IMonthlyFinancialPosition } from './MonthlyFinancialPosition.interface';

export default class MonthlyFinancialPosition implements IMonthlyFinancialPosition {
  netIncome: MonthlyFinancialPositionItem;
  lessTotalCurrentRepayment: MonthlyFinancialPositionItem;
  lessTotalProposedRepayment: MonthlyFinancialPositionItem;
  lessTotalCurrentExpenses: MonthlyFinancialPositionItem;
  foreseeableFinancialChanges: MonthlyFinancialPositionForeseeableFinancialChanges;
  surplusDeficit: MonthlyFinancialPositionItem;
  totalAssets: number;
  totalLiabilities: number;
  netAssetPosition: number;
  totalOutgoings: number;
  netCashPosition: number;
  financialRisk: number;
  hemVariance: number;
  debtToIncomeRatio: number;
  totalWords: number;

  static build = (data: IMonthlyFinancialPosition) => new MonthlyFinancialPosition(data);
  static blank = () => new MonthlyFinancialPosition({ isActive: true });

  /**
   * Constructor
   * @param {IMonthlyFinancialPosition} data
   */
  constructor(data?: IMonthlyFinancialPosition) {
    this.netIncome = new MonthlyFinancialPositionItem(data?.netIncome);
    this.lessTotalCurrentRepayment = new MonthlyFinancialPositionItem(
      data?.lessTotalCurrentRepayment
    );
    this.lessTotalProposedRepayment = new MonthlyFinancialPositionItem(
      data?.lessTotalProposedRepayment
    );
    this.lessTotalCurrentExpenses = new MonthlyFinancialPositionItem(
      data?.lessTotalCurrentExpenses
    );
    this.foreseeableFinancialChanges = new MonthlyFinancialPositionForeseeableFinancialChanges(
      data?.foreseeableFinancialChanges
    );
    this.surplusDeficit = new MonthlyFinancialPositionItem(data?.surplusDeficit);
    this.totalAssets = parseFloat(data?.totalAssets || 0);
    this.totalLiabilities = parseFloat(data?.totalLiabilities || 0);
    this.netAssetPosition = parseFloat(data?.netAssetPosition || 0);
    this.totalOutgoings = parseFloat(data?.totalOutgoings || 0);
    this.netCashPosition = parseFloat(data?.netCashPosition || 0);
    this.financialRisk = parseFloat(data?.financialRisk || 0);
    this.hemVariance = parseFloat(data?.hemVariance || 0);
    this.debtToIncomeRatio = parseFloat(data?.debtToIncomeRatio || 0);
    this.totalWords = parseFloat(data?.totalWords || 0);
  }
}
